import { render, staticRenderFns } from "./page-section-heading.vue?vue&type=template&id=0fd2697c"
import script from "./page-section-heading.vue?vue&type=script&lang=ts"
export * from "./page-section-heading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd2697c')) {
      api.createRecord('0fd2697c', component.options)
    } else {
      api.reload('0fd2697c', component.options)
    }
    module.hot.accept("./page-section-heading.vue?vue&type=template&id=0fd2697c", function () {
      api.rerender('0fd2697c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page-section-heading.vue"
export default component.exports